// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__H6yG9","left":"style__left__PjcTd","right":"style__right__X8NUB","itemContainer":"style__itemContainer__i0KE8","colorBox":"style__colorBox__s9f6o"};